// Module
var code = `<hs-sidebar></hs-sidebar>
<hs-page></hs-page>
`;
// Exports
export default code;